import React, { useState } from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

import android from "../../../images/icgal_home.png";
import iphone from "../../../images/iciphome.png";
import iphone1 from "../../../images/ic_ip_1.png";
import iphone2 from "../../../images/ic_ip_2.png";
import iphone3 from "../../../images/ic_ip_3.png";
import iphone4 from "../../../images/ic_ip_4.png";
import android1 from "../../../images/icgal1.png";
import android2 from "../../../images/icgal2.png";
import android3 from "../../../images/icgal3.png";
import android4 from "../../../images/icgal4.png";
import android5 from "../../../images/icgal5.png";
import android6 from "../../../images/icgal6.png";

const images = [
  {
    urls: android1,
    description: "1. 메인화면 하단 오른쪽 버튼 클릭",
    subdes:
      "페이지 오른쪽 하단에 보이는 '☰'를 클릭합니다. \n \n \n * 삼성인터넷으로 접속해주세요.\n \n ",
    add: "** 업데이트 상황에 따라 세부내용은 달라질 수 있습니다.",
  },
  {
    urls: android2,
    description: "2. 현재 페이지 추가 버튼 클릭",
    subdes: "'현재 페이지 추가' 버튼을 클릭합니다.",
  },
  {
    urls: android3,
    description: "2. 홈 화면 버튼 클릭",
    subdes: "페이지 하단에 보이는 '홈 화면' 버튼을 클릭합니다.",
  },
  {
    urls: android4,
    description: "3. 이름 설정 후 추가 버튼 클릭",
    subdes: "보기 편한 이름으로 설정 후 '추가' 버튼을 클릭합니다.",
  },
  {
    urls: android5,
    description: "3. 이름 설정 후 추가 버튼 클릭",
    subdes: "보기 편한 이름으로 설정 후 '추가' 버튼을 클릭합니다.",
  },
  {
    urls: android6,
    description: "4. 홈 화면에 바로가기 아이콘 생성",
    subdes: "홈 화면에 바로가기 아이콘이 생성된 것을 확인할 수 있습니다.",
  },
];
const iphImages = [
  {
    urls: iphone1,
    description: "1. 메인화면 하단 내보내기 버튼 클릭",
    subdes: "페이지 오른쪽 하단에 보이는 '내보내기 아이콘'을 클릭합니다.\n \n ",
    add: "** 업데이트 상황에 따라 세부내용은 달라질 수 있습니다.",
  },
  {
    urls: iphone2,
    description: "2. 홈 화면에 추가 버튼 클릭",
    subdes: "페이지 하단에 보이는 '홈 화면에 추가' 버튼을 클릭합니다.",
  },
  {
    urls: iphone3,
    description: "3. 이름 설정 후 추가 버튼 클릭",
    subdes: "보기 편한 이름으로 설정 후 '추가' 버튼을 클릭합니다.",
  },
  {
    urls: iphone4,
    description: "4. 홈 화면에 바로가기 아이콘 생성",
    subdes: "홈 화면에 바로가기 아이콘이 생성된 것을 확인할 수 있습니다.",
  },
];

function MediaControlCard({
  images,
  currentIndex,
  handleNext,
  handlePrevious,
}) {
  const theme = useTheme();
  const currentImage = images[currentIndex].urls;
  const currentDescription = images[currentIndex].description;
  const currentSubdes = images[currentIndex].subdes;
  const currentAdd = images[currentIndex].add;

  return (
    <div className="cardDiv">
      <Card sx={{ display: "flex" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CardContent
            sx={{
              flex: "1 0 auto",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography component="div" variant="h5">
              {currentDescription}
            </Typography>
            <br />
            <br />
            <br />
            <Typography
              variant="subtitle1"
              color="text.secondary"
              component="div"
            >
              <pre>
                {currentSubdes}
                <small>{currentAdd}</small>
              </pre>
            </Typography>
          </CardContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pl: 1,
              pb: 1,
            }}
          >
            <IconButton aria-label="previous" onClick={handlePrevious}>
              {theme.direction === "rtl" ? (
                <SkipNextIcon />
              ) : (
                <SkipPreviousIcon />
              )}
            </IconButton>
            <IconButton aria-label="play/pause">
              <PlayArrowIcon className="playicon" />
            </IconButton>
            <IconButton aria-label="next" onClick={handleNext}>
              {theme.direction === "rtl" ? (
                <SkipPreviousIcon />
              ) : (
                <SkipNextIcon />
              )}
            </IconButton>
          </Box>
        </Box>
        <CardMedia
          component="img"
          image={Array.isArray(currentImage) ? currentImage[0] : currentImage}
          alt={images[currentIndex].description}
        />
      </Card>
    </div>
  );
}

function AirService() {
  const [open, setOpen] = useState(false);
  const [iphOpen, setIphOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIphIndex, setCurrentIphIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrevious = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  const handleIphNext = () => {
    setCurrentIphIndex((prevIndex) => (prevIndex + 1) % iphImages.length); // currentIphIndex 상태를 업데이트하는 함수입니다.
  };

  const handleIphPrevious = () => {
    setCurrentIphIndex(
      (prevIndex) => (prevIndex - 1 + iphImages.length) % iphImages.length
    ); // currentIphIndex 상태를 업데이트하는 함수입니다.
  };

  const handleAndroidClick = () => {
    setCurrentIndex(0);
    setOpen(true);
  };

  const handleIphoneClick = () => {
    setCurrentIphIndex(0);
    setIphOpen(true);
  };

  return (
    <main className="airService">
      <div className="title">
        <h1> 홈 화면에 추가하기</h1>
      </div>
      <div className="homeadd">
        <img src={android} alt="homeadd" onClick={handleAndroidClick} />
        <img src={iphone} alt="homeadd" onClick={handleIphoneClick} />
      </div>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogContent>
          <DialogTitle>안드로이드폰</DialogTitle>
          <DialogContent>
            <MediaControlCard
              images={images}
              currentIndex={currentIndex}
              handleNext={handleNext}
              handlePrevious={handlePrevious}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>닫기</Button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog open={iphOpen} onClose={() => setIphOpen(false)}>
        <DialogContent>
          <DialogTitle>아이폰</DialogTitle>
          <DialogContent>
            <MediaControlCard
              images={iphImages}
              currentIndex={currentIphIndex}
              handleNext={handleIphNext}
              handlePrevious={handleIphPrevious}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIphOpen(false)}>닫기</Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      {/* <div className="airServiceFooter">
        <img src={logo} alt="airFooter" />
      </div> */}
    </main>
  );
}

export default AirService;
